import { Navigate, Outlet } from "react-router-dom";
import { useKomutStore } from "@lib/store";
import { ROUTES } from "@utils/navigation/routes";

/** Redirect authenticated users away from auth pages. */
export function GuestRoute() {
  const userInfo = useKomutStore((s) => s.userInfo);
  const clientSessionResolved = useKomutStore((s) => s.clientSessionResolved);

  if (!clientSessionResolved) {
    return (
      <div className="flex min-h-[50dvh] items-center justify-center text-muted-foreground">
        Loading…
      </div>
    );
  }

  if (userInfo) {
    return <Navigate to={ROUTES.HOME} replace />;
  }

  return <Outlet />;
}
